// eslint-ignore
export default
`<StatusBadge variant="success">Verified</StatusBadge>
<StatusBadge variant="warning">Pending</StatusBadge>
<StatusBadge variant="danger">Overdue</StatusBadge>
<StatusBadge variant="primary">Completed</StatusBadge>
<StatusBadge variant="secondary">On Hold</StatusBadge>
 
export default {
  components: { StatusBadge }
}`;